import styles from "./BackButton.module.css"
function BackButton({onClick}){
    return <div onClick={onClick} className={styles.button}>
        <i className="fa-solid fa-arrow-left"></i>
    </div>
}
export default BackButton